import { Modal, ModalWithTransition } from '@studiometa/ui';

/**
 * StyledModal component
 * Generic modal with transitions for content display
 */
export default class StyledModal extends ModalWithTransition {
  static config = {
    name: 'StyledModal',
    refs: [...Modal.config.refs],
    options: {
      styles: {
        type: Object,
        /**
         * @returns {ModalStylesOption}
         */
        default: () => ({
          modal: {
            closed: {
              opacity: '0',
              pointerEvents: 'none',
            },
            open: {
              opacity: '1',
              pointerEvents: 'auto',
            },
          },
          overlay: {
            closed: 'opacity-0',
          },
          container: {
            closed: 'translate-x-full opacity-0',
          },
        }),
      },
    },
  };

  /**
   * Mounted hook - Add click listener on desktop
   */
  mounted() {
    super.mounted();

    this.boundHandleClick = this.handleClick.bind(this);

    this.$el.addEventListener('click', this.boundHandleClick);
  }

  /**
   * Handle click on modal wrapper
   * @param {Event} event
   */
  handleClick(event) {
    if (window.innerWidth <= 1024) {
      return;
    }

    if (this.isOpen) {
      return;
    }

    if (this.$refs.open && this.$refs.open.some((btn) => btn.contains(event.target))) {
      return;
    }

    if (this.$refs.modal && this.$refs.modal.contains(event.target)) {
      return;
    }

    this.open();
  }

  /**
   * Destroyed hook - Clean up event listener
   */
  destroyed() {
    if (this.boundHandleClick && this.$el) {
      this.$el.removeEventListener('click', this.boundHandleClick);
    }

    if (document.documentElement.style.overflow === 'hidden') {
      document.documentElement.style.overflow = '';
    }

    super.destroyed();
  }
}
